import { NETWORK_CHAIN } from '@/constants/index'

export const chainParams = {
  chain: NETWORK_CHAIN,
}
